import styled from 'styled-components';

const Paragraph = styled.p`
  max-width: 650px;
  font-size: 0.7rem;
  text-align: center;
`;

export function LegalNotice() {
  return (
    <Paragraph>
      Love Me Doku is an independent, fan-created project and is not affiliated
      with, endorsed by, or connected to The Beatles, Apple Corps Ltd., or any
      of their affiliates. All trademarks, names, and images related to The
      Beatles are the property of their respective owners and are used here for
      informational and entertainment purposes only.
    </Paragraph>
  );
}
